import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { cx } from '@emotion/css';

import { ContentWrapper } from '../../../../common/content-wrapper';
import { useStyles } from './sign-up-slide.styles';
import { Button } from '../../../../common/button-new';
import { SignUpSlideProps } from './sign-up-slide.models';

export const SignUpSlide = ({ title, description, isDark }: SignUpSlideProps): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <ContentWrapper withoutPaddings>
      <div data-testid="slide" className={cx({ [classes.dark]: isDark })}>
        <div className={classes.content} data-testid="slide-content">
          <h1 className={cx(classes.title, { [classes.textLight]: isDark })} data-testid="title">
            {intl.formatMessage(
              { id: title },
              { sup: (chunks: ReactNode) => <sup>{chunks}</sup>, nonBreakSpace: <>&nbsp;</> },
            )}
          </h1>
          <p
            className={cx(classes.description, { [classes.textLight]: isDark }, { [classes.textDark]: !isDark })}
            data-testid="description"
          >
            {intl.formatMessage(
              { id: description },
              { sup: (chunks: ReactNode) => <sup>{chunks}</sup>, nonBreakSpace: <>&nbsp;</> },
            )}
          </p>
          <Button
            testId="signup-link"
            rootClasses={cx(classes.button, { light: isDark })}
            textClasses={cx(classes.buttonText, { light: isDark })}
            to="#adult"
            style="dark"
          >
            <FormattedMessage id="regGuide.banner.button.adult" />
          </Button>
          <Button
            testId="signup-link"
            rootClasses={cx(classes.button, classes.childButton, { white: isDark })}
            textClasses={cx(classes.buttonText, { white: isDark })}
            to="#child"
            style="outlined"
          >
            <FormattedMessage id="regGuide.banner.button.child" />
          </Button>
        </div>
        <div aria-hidden="true" data-testid="slide-img" className={isDark ? classes.imgNew : classes.img} />
      </div>
    </ContentWrapper>
  );
};
